import { render, staticRenderFns } from "./NewDTextareaPreview.vue?vue&type=template&id=3b18357e&"
import script from "./NewDTextareaPreview.vue?vue&type=script&lang=js&"
export * from "./NewDTextareaPreview.vue?vue&type=script&lang=js&"
import style0 from "./NewDTextareaPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports